module.exports = __webpack_public_path__ + "static/media/KW12_as1.13cefa8f.JPG";